import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Beef, Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin(intentRole = null) {
  if (intentRole) localStorage.setItem("cw_google_intent_role", intentRole);
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo(a) de volta!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const quick = (e, p) => { setEmail(e); setPassword(p); };

  return (
    <div className="min-h-screen grain flex items-center justify-center px-4 relative z-10">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 rounded-xl bg-red-600 flex items-center justify-center">
            <Beef className="w-5 h-5 text-white" />
          </div>
          <span className="font-display font-extrabold text-xl">CarnesWork</span>
        </Link>

        <div className="cw-card p-8 anim-fade-up">
          <h1 className="text-2xl font-display font-bold mb-1">Entrar</h1>
          <p className="text-sm text-zinc-400 mb-6">Acesse seu painel</p>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-wider text-zinc-500 mb-1.5">Email</label>
              <input value={email} onChange={e => setEmail(e.target.value)} type="email" required
                     className="cw-input" data-testid="input-login-email" placeholder="voce@email.com" />
            </div>
            <div>
              <label className="block text-xs uppercase tracking-wider text-zinc-500 mb-1.5">Senha</label>
              <input value={password} onChange={e => setPassword(e.target.value)} type="password" required
                     className="cw-input" data-testid="input-login-password" placeholder="••••••••" />
            </div>
            <button type="submit" disabled={loading} className="cw-btn-primary w-full flex items-center justify-center gap-2" data-testid="btn-login-submit">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Entrando…</> : "Entrar"}
            </button>
          </form>

          <div className="my-5 flex items-center gap-3 text-[10px] uppercase tracking-widest text-zinc-500">
            <div className="h-px flex-1 bg-zinc-800" />
            ou
            <div className="h-px flex-1 bg-zinc-800" />
          </div>

          <button onClick={() => startGoogleLogin()} type="button"
                  className="w-full flex items-center justify-center gap-3 rounded-xl border border-zinc-700 hover:border-zinc-500 bg-white text-zinc-900 font-semibold py-2.5 transition-colors"
                  data-testid="btn-google-login">
            <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
              <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.3 30.2 0 24 0 14.6 0 6.4 5.4 2.6 13.2l7.8 6C12.2 13 17.6 9.5 24 9.5z"/>
              <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.9 7.2l7.5 5.8c4.4-4.1 7.2-10.1 7.2-17.5z"/>
              <path fill="#FBBC05" d="M10.4 28.9a14.4 14.4 0 0 1 0-9.8l-7.8-6a24 24 0 0 0 0 21.6l7.8-5.8z"/>
              <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.8 2.2-8.4 2.2-6.4 0-11.8-3.5-13.6-9.4l-7.8 5.8C6.4 42.6 14.6 48 24 48z"/>
            </svg>
            Entrar com Google
          </button>

          <div className="mt-6 border-t border-zinc-800 pt-6">
            <div className="text-xs text-zinc-500 mb-3 uppercase tracking-wider">Testar rapidamente</div>
            <div className="grid grid-cols-2 gap-2">
              <button onClick={() => quick("acougue@demo.com", "demo123")} className="cw-btn-outline text-xs" data-testid="btn-demo-comercio">
                Demo Comércio
              </button>
              <button onClick={() => quick("carlos@demo.com", "demo123")} className="cw-btn-outline text-xs" data-testid="btn-demo-acougueiro">
                Demo Açougueiro
              </button>
            </div>
          </div>

          <p className="text-sm text-zinc-400 text-center mt-6">
            Não tem conta? <Link to="/register" className="text-red-500 font-semibold" data-testid="link-goto-register">Cadastre-se</Link>
          </p>
          <p className="text-xs text-zinc-500 text-center mt-2">
            <Link to="/forgot-password" className="hover:text-white" data-testid="link-forgot">Esqueci minha senha</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
